<template>
  <section class="v-cal-content">
    <div class="v-cal-weekdays">
      <div class="v-cal-weekdays__padding">
        <div class="v-cal-times">
          <!--Fake, hidden time-->
          <div class="v-cal-hour">00:00 <template v-if="use12">PM</template></div>
        </div>
      </div>
      <div class="v-cal-weekday__wrapper">
        <div class="v-cal-weekday-item" v-for="(day, index) in days" :key="index">
          <div>
            <div>{{day.d.format('ddd')}}</div>
            <div>{{day.d.format('DD')}}</div>
          </div>
          <div><span v-if="Number(day.timeWorked) > 0">{{day.timeWorked.toFixed(1)}}h</span></div>
        </div>
      </div>
    </div>
    <div class="v-cal-days">
      <div class="v-cal-times">
        <div class="v-cal-hour" :class="{ 'is-now': time.isSame(now, 'hour') }" v-for="(time, index) in times" :key="index">{{ time | formatTime(use12) }}</div>
      </div>
      <div class="v-cal-days__wrapper">
        <div class="v-cal-day v-cal-day--week" v-for="(day, index) in days" :class="{ 'is-today': day.isToday, 'is-disabled': day.isDisabled }" :key="index">
          <div class="v-cal-day__hour-block"
               @click="timeClicked({ date: day.d.toDate(), time: time.hour() })"
               :class="[ time.hour() === now.hour() ? 'is-now' : '', hourClass, time.hour() >= 8 && time.hour() <= 16 && time.day() < 6 && time.day() > 0 ? 'workday-hour' : '' ]" v-for="(time, index) in day.availableTimes" :key="index">
            <span class="v-cal-day__hour-block-fill">{{ time | formatTime(use12) }}</span>
            <div class="v-cal-day__hour-content">
              <div class="v-cal-event-list">
                <event-item
                        v-for="(event, index) in day.events.filter(event => {return event.startTime && time.hours() === event.startTime.hours()})"
                        :key="index"
                        :event="event"
                        :use12="use12"
                        >
                </event-item>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import { EventBus } from '../EventBus'
import EventItem from '../EventItem'
import IsView from '../mixins/IsView'
import ShowsTimes from '../mixins/ShowsTimes'

export default {
  name: 'week',
  mixins: [ IsView, ShowsTimes ],
  components: { EventItem },
  data () {
    return {
      days: []
    }
  },
  mounted () {
    this.buildCalendar()
  },
  methods: {

    timeClicked (data) {
      EventBus.$emit('time-clicked', data)
    },
    buildCalendar () {
      let now = moment()

      let temp = moment(this.activeDate).day(moment.localeData().firstDayOfWeek())
      let w = temp.week()

      this.days = []

      do {
        const day = moment(temp)

        const dayEvents = this.events.filter(e => e.date.isSame(day, 'day'))
          .sort((a, b) => {
            if (!a.startTime) return -1
            if (!b.startTime) return 1
            return moment(a.startTime).format('HH') - moment(b.startTime).format('HH')
          })
        const mappedEvents = dayEvents.map(event => {
          event.overlaps = dayEvents.filter(e => moment(event.startTime).isBetween(moment(e.startTime), moment(e.endTime)) && e !== event).length
          return event
        })

        let timeWorked = 0
        mappedEvents.forEach((event) => {
          if (!event.isPersonal) {
            timeWorked = Number(timeWorked) + Number(event.duration)
          }
        })

        let newDay = {
          d: day,
          isPast: temp.isBefore(now, 'day'),
          isToday: temp.isSame(now, 'day'),
          isDisabled: this.isDayDisabled(temp),
          availableTimes: this.times.map(time => moment(time).dayOfYear(day.dayOfYear())),
          events: mappedEvents,
          timeWorked: timeWorked
        }
        this.days.push(newDay)

        temp.add(1, 'day')
      } while (temp.week() === w)
    }
  },
  watch: {
    timeRange () {
      this.buildCalendar()
    }
  }
}
</script>

<style lang='scss'>
@import '@/styles/common.scss';
.v-cal-weekdays {
  max-height: initial !important;

  .v-cal-weekdays__padding{
    margin-right:-1px;
  }

  .v-cal-weekday-item {
    border-left:1px solid rgba(234, 240, 244, 1);
    display: flex;
    align-items: flex-end;
    width: 14% !important;
    padding: 20px 0px 5px 0px !important;
    font-weight: normal !important;
    font-size: 14px !important;
    color: rgba(0,0,0,0.6);

    > div {
    
      &:first-child {
        margin-left: 3px;
        text-align: left !important;
      }
      &:last-child {
        flex-grow: 1;
        text-align: right;
        color: #409eff;
        margin-right: 10px;
        line-height: 22px !important;

      }
      div:last-child {
        font-size: 22px !important;
      }
    }
  }
}
.v-cal-event-list{
  position:relative;
}
.workday-hour{
  background:rgb(255, 251, 243) !important;
}
.v-cal-times {
  width: 60px;
}
</style>
